import { gql } from '@apollo/client';

const ORDER_ITEM_FRAGMENT = gql`
  fragment orderItem on Order {
    id
    name
    financialStatus
    fulfillmentStatus
    createdAt
    cancelledAt
    totalPrice
    sourceName
    parcelTrackingUrl
    shippingAddress {
      zip
      country
      city
      address1
      address2
      company
      name
      phone
    }
    lineItems {
      variantId
      productId
      vendor
      sku
      quantity
      title
      price
      grams
      productImages {
        src
        alt
        width
        position
      }
    }
    noteAttributes {
      name
      value
    }
    fulfillments {
      trackingCompany
      trackingUrl
      trackingUrls
      trackingNumber
      trackingNumbers
    }
    updatedTimeSlot {
      deliveryDate
      endTime
      startTime
    }
  }
`;

export const GET_CUSTOMER_ORDER = gql`
  query GetCustomerOrder($cursor: String, $pageSize: Int, $from: String) {
    getCustomerOrder(cursor: $cursor, pageSize: $pageSize, from: $from) {
      cursor
      items {
        ...orderItem
      }
    }
  }
  ${ORDER_ITEM_FRAGMENT}
`;

export const GET_LAST_CUSTOMER_ORDER_TRACKERS = gql`
  query GetLastCustomerOrderTrackers {
    getOrderTrackers {
      orderNumber
      orderedAt
      canceled
      noteAttributes {
        name
        value
      }
      fulfillments {
        data {
          statusCode
          trackers {
            data {
              deliveryStatusCode
              carrier {
                code
              }
              deliveredAt
            }
          }
        }
      }
    }
  }
`;

export const GET_LAST_ORDER_TRACKING_EVENT = gql`
  query GetLastOrderTrackingEvent {
    getLastOrderTrackingEvent {
      orderId
      orderNumber
      status
      trackingUrl
      updatedAt
      expectedDeliveryTimeSlot {
        start
        end
      }
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation CancelOrder($orderId: ID!) {
    cancelOrder(id: $orderId) {
      ...orderItem
    }
  }
  ${ORDER_ITEM_FRAGMENT}
`;

export const GET_ORDER = gql`
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      ...orderItem
    }
  }
  ${ORDER_ITEM_FRAGMENT}
`;

export const GET_CUSTOMER_LAST_ORDER = gql`
  query GetCustomerLastOrder {
    getCustomerLastOrder {
      ...orderItem
    }
  }
  ${ORDER_ITEM_FRAGMENT}
`;

export const CREATE_PACKAGE_INVOICE = gql`
  mutation CreatePackageInvoice($shipmentId: String!) {
    createPackageInvoice(shipmentId: $shipmentId) {
      invoiceUrl
    }
  }
`;

export const GET_USER_SAVINGS = gql`
  query GetCustomerSavings($from: String!) {
    getCustomerSavings(from: $from) {
      totalSavings
      totalOrders
    }
  }
`;
